import ShopifyLogo from "../../../../assets/img/shopify.PNG";
import Whatsapp from "../../../../assets/img/whatsapp.png";

export const questionnaires = [
  {
    question: "How did you come across to U - SEND?",
    answer: "",
  },
  {
    question: "What niche are you mainly selling in?",
    answer: "",
  },
  {
    question: "What is your average daily order volume?",
    answer: "",
  },
  {
    question: "Do you handle customer service yourself?",
    answer: "",
  },
  {
    question: "What language do you speak?",
    answer: "",
  },
  {
    question: "How did you handle order fulfillment before?",
    answer: "",
  },
];

export const dummyStores = [
  {
    id: 1,
    custom_store_name: "Levora Fashion",
    store_name: "105593-2.myshopify.com",
  },
  {
    id: 2,
    custom_store_name: "Lumière Fresh",
    store_name: "308972-4.myshopify.com",
  },
];
export const portalServices = [
  {
    id: 1,
    title: "Seamless Integration",
    img: "https://u-send.s3.eu-west-2.amazonaws.com/shopify-logo.png",
    desc: "All of your products and orders will be synchronized through your Shopify connection. This will allow you to create an optimal workflow.",
  },
  {
    id: 2,
    title: "Dedicated Support",
    img: Whatsapp,
    desc: "Say Hi to us via Whatsapp! We are here to support you whenever you have any issues with the portal.",
  },
];

export const storeInstructions = (email='') =>{
  return [
    {
      id: 1,
      title: "New store account",
      desc: (
        <>
          Log in on Shopify in an {<strong>INCOGNITO BROWSER</strong>} in your
          new store. Here, go to the Shopify App Store and search for 
          {<strong> U-Send Fulfillment.</strong>} Install the app and complete the
          account creation process.
        </>
      ),
    },
    {
      id: 2,
      title: "Team addition",
      desc: (
        <>
          In your new U-Send account, created in the previous step. Head to 
          {<strong> settings {">"} team.</strong>} From here, simply click add user
          and add {<strong style={{ color: "#7F56D9" }}>{email}.</strong>}
        </>
      ),
    },
  ]
}
